"use client";

import * as React from "react";
import { Star } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
const testimonials = [{
  id: 1,
  rating: 5,
  source: "Class of 2005",
  quote: "Walking through those halls again felt like stepping back in time. Skyline High shaped who I am today, and seeing everyone after twenty years is a gift I didn't know I needed.",
  author: "David Miller, Senior Class President"
}, {
  id: 2,
  rating: 5,
  source: "Varsity Alumni",
  quote: "The nostalgia is overwhelming in the best way possible. From the old gym to the cafeteria, the memories came flooding back. This reunion is the perfect tribute to our legacy.",
  author: "Elena Rodriguez, Head Cheerleader"
}, {
  id: 3,
  rating: 5,
  source: "Honor Society",
  quote: "Twenty years later, the bond of the Class of 2005 remains unbroken. It's incredible to see how far we've all come while still sharing that same Skyline spirit we had at graduation.",
  author: "Marcus Chen, Valedictorian"
}];
export default function VoicesFromTheClass() {
  return <section data-section-id="259618" id="voices-from-the-class" className="bg-background text-foreground py-24 sm:py-32 overflow-hidden">
      <div className="page-container">
        <div className="mx-auto max-w-4xl relative">
          <Carousel opts={{
          loop: true,
          align: "center"
        }} className="w-full">
            <CarouselContent>
              {testimonials.map((testimonial, i) => <CarouselItem key={testimonial.id} data-index={i}>
                  <div className="flex flex-col items-center text-center px-4 sm:px-16 py-8">
                    {}
                    <div className="flex items-center gap-3 mb-8">
                      <div className="flex gap-1">
                        {[...Array(testimonial.rating)].map((_, j) => <Star key={j} className="size-4 fill-primary text-primary" />)}
                      </div>
                      <span className="text-xs font-default font-semibold text-primary tracking-widest uppercase">
                        {testimonial.source}
                      </span>
                    </div>

                    {}
                    <p className="text-lg sm:text-xl md:text-3xl italic text-foreground leading-relaxed mb-8 font-serif">
                      "{testimonial.quote}"
                    </p>

                    {}
                    <p className="text-sm font-default font-medium text-muted-foreground tracking-wider uppercase">
                      — {testimonial.author}
                    </p>
                  </div>
                </CarouselItem>)}
            </CarouselContent>
            
            {}
            <div className="hidden sm:block">
              <CarouselPrevious variant="ghost" className="text-primary hover:text-primary/80 hover:bg-transparent border-none size-12 [&_svg]:size-8 -left-4 md:-left-12 transition-colors" />
              <CarouselNext variant="ghost" className="text-primary hover:text-primary/80 hover:bg-transparent border-none size-12 [&_svg]:size-8 -right-4 md:-right-12 transition-colors" />
            </div>
          </Carousel>
        </div>
      </div>
    </section>;
}